import gql from 'graphql-tag';

export default gql`
    mutation EditJobNotes($input: JobNotesEdit) {
        editJobNotes(input: $input) {
            errors
        }
    }
`;
